import Popup from "../../../../../common/components/popup";
import ModalPackageItemComponent from "./modal-package-details";
import { useRef, useState } from "react";
import { deepCopy } from "../../../../../common/services/common.service";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { YesNoRendererComponent } from "../../../../../common/components/yes-no-renderer.component";
import MobileViewTable from "../../../../../common/components/mobile-view-table.component";
import PopupMobile from "../../../../../common/components/popup-mobile.component";

export default function PackageDetails({ handleDelete, handleSavePackageItem, closeModal, handleEdit, handleAddItem, PackageType, handleInnerFormChange, columnDefs, variantLists, ProductLists, categoryListItems, packageItem, selectedPackageItem, addPackageItem, handleSteps }: any) {

  const NewPackageItemPopup = ({ handleSavePackageItem }: any) => {
    const [localPackItems, setLocalPackItems] = useState(deepCopy(selectedPackageItem));
    const handleLocalFormChange = (value: any, field: any) => {
      setLocalPackItems((prev: any) => ({
        ...prev,
        [field]: value,
      }));
    };
    const handleFormSubmit = () => {
      setLocalPackItems(localPackItems);
      handleSavePackageItem(localPackItems)
    };
    return (
      <>
        <PopupMobile onClose={closeModal}>
          <ModalPackageItemComponent
            Close={closeModal}
            selectedPackageItem={localPackItems}
            PackageType={PackageType}
            handlePackageItemSubmit={handleFormSubmit}
            ProductLists={ProductLists}
            categoryListItems={categoryListItems}
            variantLists={variantLists}
            handleInnerFormChange={handleLocalFormChange}

          />

        </PopupMobile>
      </>
    )
  }

  const additionButtons: any = [
    {

      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Item</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAddItem(),
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleRightScroll = () => {
    if (currentIndex < packageItem.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleLeftScroll = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1)
    }
  };

  return (
    <>
      <div className="justify-center items-center md:hidden">
        <div className="h-[550px] min-w-[300px] max-w-[500px] mx-auto">
          <div className="flex flex-col justify-center items-start p-5 space-y-5">
            <div className="w-full">
              <MobileViewTable
                columnData={columnDefs}
                rowData={packageItem}
                onEdit={handleEdit}
                headingName="Package Details"
                additionButtons={additionButtons}
                onDelete={handleDelete}
              />
            </div>

            <div className="w-full flex justify-end px-5 space-x-3 pb-20">
              <button
                onClick={handleSteps}
                className="px-4 py-2 bg-blue-900 text-white rounded-md"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      {
        addPackageItem ? <NewPackageItemPopup handleSavePackageItem={handleSavePackageItem} /> : <></>
      }
    </>
  );
}
